import React, { useContext, useState, useEffect } from 'react';
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from '@material-ui/core/styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as actions from '../actions/actions';
import { TextField, Grid, MenuItem, IconButton, Switch, FormControlLabel } from '@material-ui/core';
import { config } from '../helpers/constants';
import AddIcon from '@material-ui/icons/Add';
import ShareIcon from "@material-ui/icons/Share";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles({
    paCenterHeader: {
        display: "flex",
        height: '56px',
        backgroundColor: "#eeeeee",
        alignItems: "center",
        margin: "0",
        paddingLeft: 15,
        paddingRight: 15,
        zIndex: 5,
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        position: "relative",
        flexWrap: "nowrap"
    },
    titleHead: {
        fontSize: "1.5rem",
        flex: "5 1",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    filterField: {
        flex: "1 1",
        marginLeft: 5,
        marginRight: 5,
    },
    controls: {
        display: "flex",
        flex: "0 1 800px",
        alignItems: "center",
    },
    iconButton: {
        marginLeft: 5,
        marginRight: 5,
    }
});

export default function LibraryTitle(props) {
    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const apiUrl = config.apiUrl;

    // local search phrase to prevent treiggering update on changes, this will be handled via timeout 
    const [searchPhrase, setSearchPhrase] = useState(state.libraryFilter.search);
    const [ownerPhrase, setOwnerPhrase] = useState(state.libraryFilter.ownermail);
    const [searchTimeoutId, setSearchTimeoutId] = useState(0);
    const [ownerTimeoutId, setOwnerTimeoutId] = useState(0);

    const isAdmin = state.user && state.user.license && state.user.userId == state.user.license.adminUserId;

    // Capture external changes in library state and reflect it in the local var
    useEffect(() => {
        setSearchPhrase(state.libraryFilter.search);
    }, [state.libraryFilter.search]);

    useEffect(() => {
        setOwnerPhrase(state.libraryFilter.ownermail);
    }, [state.libraryFilter.ownermail]);


    const onCopied = () => {
        dispatch(actions.openToast({ type: "success", message: "Link to plagiarism library copied to clipboard", status: true }));
    }

    const handlePdfDownload = () => {
        window.open(apiUrl + state.activeLibrary.PdfLink, "_blank");
    }

    const onApplyLibraryFilter = (filter) => {
        dispatch(actions.apply_library_filter(filter));
    }

    const onSearchChanged = (e) => {
        setSearchPhrase(e.target.value);
        clearTimeout(searchTimeoutId);
        setSearchTimeoutId(setTimeout(onApplyLibraryFilter, 500, { ...state.libraryFilter, search: e.target.value }));
    }

    const onOwnerChanged = (e) => {
        setOwnerPhrase(e.target.value);
        clearTimeout(ownerTimeoutId);
        setOwnerTimeoutId(setTimeout(onApplyLibraryFilter, 500, { ...state.libraryFilter, ownermail: e.target.value }));
    }

    const onIncludeLicenseTextsChanged = (e) => {
        const checked = e.target.checked;
        if (checked) {
            onApplyLibraryFilter({ ...state.libraryFilter, includeLicenseTexts: 1 });
        } else {
            setOwnerPhrase("");
            onApplyLibraryFilter({ ...state.libraryFilter, includeLicenseTexts: 0, ownermail: "" });
        }
    }

    const onResetLibraryFilter = () => {
        dispatch(actions.clear_library_filter());
    }

    const createNewLibrary = () => {
        dispatch(actions.navigate_to("/library/new"))
    }

    return (
        <div className={classes.paCenterHeader}>
            <div className={classes.titleHead} >
                {props.title}
            </div>
            {props.type === "LibraryReview" ?
                <Grid>
                    <CopyToClipboard text={`${apiUrl}${state.activeLibrary.HtmlLink}`} onCopy={onCopied}>
                        <IconButton className={classes.iconButton}>
                            <ShareIcon />
                        </IconButton>
                    </CopyToClipboard>
                    <IconButton className={classes.iconButton} onClick={handlePdfDownload}>
                        <DownloadIcon />
                    </IconButton>
                    <IconButton className={classes.iconButton}>
                        <MoreVertIcon />
                    </IconButton>
                </Grid>
                : ""
            }
            {props.type === "LibraryOverview" ?
                <div className={classes.controls}>
                    <TextField size="small"
                        variant="outlined"
                        label={s.search}
                        className={classes.filterField}
                        style={{ flex: isAdmin ? "1 1" : "2 1" }}
                        value={searchPhrase}
                        onChange={onSearchChanged}
                    />
                    {state.projects.length > 0 &&
                    <TextField className={classes.filterField}
                        select
                        label={s.project}
                        variant="outlined"
                        size="small"
                        value={state.libraryFilter.projectId}
                        onChange={(evt) => onApplyLibraryFilter({ ...state.libraryFilter, projectId: evt.target.value })}
                    >
                        <MenuItem value="">{s.filter.allProjects}</MenuItem>
                        {state.projects.map((proj) => (
                            <MenuItem key={proj.Id} value={proj.Id}>{proj.Name}</MenuItem>
                        ))}
                    </TextField>}
                    <TextField className={classes.filterField}
                        select
                        label={s.date}
                        variant="outlined"
                        size="small"
                        value={state.libraryFilter.date}
                        onChange={(evt) => onApplyLibraryFilter({ ...state.libraryFilter, date: evt.target.value })}
                    >
                        <MenuItem value="">{s.filter.all}</MenuItem>
                        <MenuItem value="1">{s.filter.today}</MenuItem>
                        <MenuItem value="2">{s.filter.yesterday}</MenuItem>
                        <MenuItem value="3">{s.filter.last7days}</MenuItem>
                        <MenuItem value="4">{s.filter.last30days}</MenuItem>
                        <MenuItem value="5">{s.filter.thisMonth}</MenuItem>
                        <MenuItem value="6">{s.filter.lastMonth}</MenuItem>
                        <MenuItem value="7">{s.filter.thisYear}</MenuItem>
                        <MenuItem value="8">{s.filter.lastYear}</MenuItem>

                    </TextField>
                    {isAdmin && state.user.license.allowViewLicenseLibtexts && state.libraryFilter.includeLicenseTexts === 1 &&
                    <TextField size="small"
                        variant="outlined"
                        label={s.common.owner}
                        className={classes.filterField}
                        value={ownerPhrase}
                        onChange={onOwnerChanged}
                    />}
                    {isAdmin && state.user.license.allowViewLicenseLibtexts &&
                    <FormControlLabel
                        style={{ marginLeft: 10 }}
                        control={<Switch checked={state.libraryFilter.includeLicenseTexts === 1} onChange={onIncludeLicenseTextsChanged} />}
                        label={s.libraryOverview.licenseTexts}
                    />}

                    <IconButton data-for="globalTT" data-place="bottom" data-tip={s.common.resetFilter} className={classes.iconButton} onClick={onResetLibraryFilter}>
                        <ClearIcon />
                    </IconButton>
                    <IconButton data-for="globalTT" data-place="bottom" data-tip={s.libraryOverview.newTextTip} className={classes.iconButton} onClick={createNewLibrary}>
                        <AddIcon />
                    </IconButton>
                </div>
                : ""
            }

        </div>

    )
}